import React from 'react';
import './BlogBody.css';

export default function BlogBody() {
  return (
    <div>Upcoming....</div>
  )
}
